<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { EntityListPage, getAggregatorsLookup, type EntityConfig } from '@botto/core';
import { keywordsStore } from '../../api';
import type { Keyword } from '../../api';

const aggregatorsLookup = getAggregatorsLookup();

onMounted(() => { void aggregatorsLookup.ensureLoaded(); });

const config = computed<EntityConfig<Keyword>>(() => ({
  title: 'Стоп-слово',
  titlePlural: 'Стоп-слова',
  popupWidth: 520,
  columns: [
    { dataField: 'id', caption: 'ID', dataType: 'number', width: 80 },
    { dataField: 'keyword', caption: 'Стоп-слово' },
    {
      dataField: 'aggregator_id',
      caption: 'Агрегатор',
      dataType: 'number',
      calculateDisplayValue: (row) => aggregatorsLookup.labelOf(row.aggregator_id),
    },
  ],
  fields: [
    { dataField: 'id', label: 'ID', editOnly: true, editorOptions: { readOnly: true } },
    { dataField: 'keyword', label: 'Стоп-слово', required: true },
    { dataField: 'aggregator_id', label: 'Агрегатор', lookup: aggregatorsLookup },
  ],
}));
</script>

<template>
  <EntityListPage :config="config" :store="keywordsStore" />
</template>
